var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 0C22.92 0 24 1.08 24 2.4V24L19.2 19.2H2.4C1.08 19.2 0 18.12 0 16.8V2.4C0 1.08 1.08 0 2.4 0H21.6ZM13.2004 10.8H16.8004C17.4604 10.8 18.0004 10.26 18.0004 9.6C18.0004 8.94 17.4604 8.4 16.8004 8.4H13.2004V4.8C13.2004 4.14 12.6604 3.6 12.0004 3.6C11.3404 3.6 10.8004 4.14 10.8004 4.8V8.4H7.20044C6.54044 8.4 6.00044 8.94 6.00044 9.6C6.00044 10.26 6.54044 10.8 7.20044 10.8H10.8004V14.4C10.8004 15.06 11.3404 15.6 12.0004 15.6C12.6604 15.6 13.2004 15.06 13.2004 14.4V10.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add_comment.9386f4c5.svg";
export { ForwardRef as ReactComponent };